import { buildSlice, NotificationState } from '@24sens/ecg01-notifications';

const slice = buildSlice((state: { notifications: NotificationState }) => state.notifications);

export default slice;
export const selectors = slice.selectors;
